<div class="container h-full flex flex-col gap-4 mx-auto px-4 md:px-6 pt-8 pb-4">
  <div class="flex flex-wrap items-center gap-2 min-h-10">
    <h2 class="text-2xl font-medium">Apparaten</h2>
  </div>

  <div>
    <mat-chip-listbox
      hideSingleSelectionIndicator
      class="inline-flex! py-1 px-2 bg-white rounded-full [--mdc-chip-outline-color:transparent] [--mdc-chip-container-shape-radius:24px] [--mdc-chip-label-text-color:var(--color-gray-500)] [--mdc-chip-elevated-selected-container-color:var(--color-secondary-200)] [--mdc-chip-selected-label-text-color:var(--color-secondary-800)]"
    >
      <mat-chip-option
        value="robots"
        [selected]="activeCategory() === 'robots'"
        [selectable]="activeCategory() !== 'robots'"
        (selectionChange)="handleCategoryChange($event)"
      >
        Robots
      </mat-chip-option>
      <mat-chip-option
        value="access-points"
        [selected]="activeCategory() === 'access-points'"
        [selectable]="activeCategory() !== 'access-points'"
        (selectionChange)="handleCategoryChange($event)"
      >
        Access points
      </mat-chip-option>
    </mat-chip-listbox>
  </div>

  <router-outlet style="display: contents" />
</div>
